/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_F_AreaInputs */

const cs_pm_f_area = /** @type {(inputs: Pm_F_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha`)
};

const en_pm_f_area = /** @type {(inputs: Pm_F_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area`)
};

/**
* | output |
* | --- |
* | "Area" |
*
* @param {Pm_F_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_f_area = /** @type {((inputs?: Pm_F_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_F_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_f_area(inputs)
	return cs_pm_f_area(inputs)
});